var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateQuestionnire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 513353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.50977 4.82031C5.50977 4.25077 5.97149 3.78906 6.54102 3.78906C7.11054 3.78906 7.57227 4.25077 7.57227 4.82031C7.57227 5.19841 7.36877 5.52899 7.06539 5.70851C6.80392 5.86317 6.54102 6.0978 6.54102 6.40156V7.08906",
    stroke: "#5B6B79",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.59121 8.74141C6.59121 8.76902 6.56883 8.79141 6.54121 8.79141C6.5136 8.79141 6.49121 8.76902 6.49121 8.74141C6.49121 8.71379 6.5136 8.69141 6.54121 8.69141C6.56883 8.69141 6.59121 8.71379 6.59121 8.74141Z",
    fill: "#5B6B79",
    stroke: "#5B6B79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.50005 12.0402C3.90742 12.0206 2.61105 12.0108 1.81174 11.1992C1.01238 10.3878 1.02217 9.09138 1.04176 6.49876C1.06135 3.9061 1.07115 2.60978 1.88269 1.81044C2.69417 1.01109 3.99054 1.02088 6.58316 1.04047C9.17582 1.06006 10.4721 1.06986 11.2715 1.88138C12.0708 2.6929 12.061 3.98922 12.0414 6.58187",
    stroke: "#5B6B79",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.991 13.043V9.04297M9.04102 11.043H12.941",
    stroke: "#5B6B79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateQuestionnire);
export default __webpack_public_path__ + "static/media/create_questionnire.5a7fac5e7e70b11c409b644a592a33c0.svg";
export { ForwardRef as ReactComponent };